import * as React from 'react';

import { PageTitle } from './PageTitle';

import { useApplication } from '../AppContext';

const Settings = () => {
	const app = useApplication();

	if (app === null) {
		console.log('app is', app);
	}

	return (
		<div id="Settings1" className="page1">
			<div className="wrapper">
				<PageTitle>
					<h1>Settings</h1>
				</PageTitle>

			</div>
		</div>
	);
};

export default Settings;
